import script from "./SkipNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SkipNav.vue?vue&type=script&setup=true&lang=js"

import "./SkipNav.vue?vue&type=style&index=0&id=2688e9f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2688e9f0"]])

export default __exports__